export const locale = {
  lang: 'tr',
  data: {
    MENU: {
      HOME: {
        SECTION: 'Analiz',
        DASHBOARD_TASK: 'Görev Panosu',
      },
      EMISSIONDATA: {
        SECTION: 'Emisyon Verisi',
      },
      CALCULATION: {
        SECTION: 'Hesaplama',
        DATA: 'Veri',
        DATAHISTORY: 'Geçmiş Emisyon Verisi',
        DATALASTYEARS: 'Geçmiş Yıllar Emisyon Verisi',
        BULK_UPLOAD: 'Toplu Veri Yükleme',
        EMISSION_FACTOR_CONSTANTS: 'Emisyon Faktör Sabitleri',
        SOURCE_EMISSION_FACTORS: 'Kaynak emisyon faktörleri',
        LOGISTIC_FACTORS: 'Lojistik emisyon faktörleri',
        BUSINESS_TRAVEL_AIRWAY: 'İş Seyahati Hava Yolu Taşımacılığı',
        EMISSION_FACTORS: 'Emisyon Faktörleri',
        HOTEL_ACCOMMODATION_EMISSIONS: 'Otel Konaklama Emisyonları',
      },
      ACCOUNTING: {
        SECTION: 'Muhasebe',
        EMISSION: 'Mizan',
        TREE: 'Hesap Ağacı',
        COA_SETUP: 'Hesap Planı',
        LEDGER: 'Muavin Merkezi',
        RULES: 'Kural Kütüphanesi',
        EF: 'EF Kütüphanesi',
        EF_CONSOLE: 'EF Konsolu',
        RESULTS: 'Sonuçlar',
        AUX_LEDGERS: 'Yardımcı Defterler',
        CONSOLIDATION: 'Konsolidasyon',
      },
      EMISSION_SOURCE_CREATION: {
        SECTION: 'Emisyon Kaynağı Oluşturma',
      },
      EMISSION_CATEGORY_METHODS: 'Kategori Metotları',
      CONVERSION_PARAMETERS: 'Dönüşüm Parametreleri',
      EMISSION_FACTOR_V2: {
        SECTION: 'EmisyonFactor V2',
        STATIONARY_COMBUSTION: 'Sabit yanma faktörleri',
        MOBILE_COMBUSTION: 'Hareketli yanma faktörleri',
        PURCHASED_ELECTRICITY: 'Satın alınan elektrik faktörleri',
      },
      ADMIN: {
        SECTION: 'Yönetim',
        MYCOMPANY: 'Şirketim',
        USERMANAGEMENT: 'Kullanıcı Yönetimi',
        ROLES: 'Roller',
        LOCATIONS: 'Lokasyonlar',
        SUBCOMPANY: 'Alt Şirketler',
        EQUIPMENTS: 'Ekipmanlar',
        WASTEWATERTREATMENT: 'Atıksu Arıtma Tesisleri',
      },
      SUPERADMIN: {
        SECTION: 'Analiz',
      },
      APPLICATIONADMIN: {
        SECTION: 'Grup Şirketleri',
      },
      APPLICATIONMANAGEMENT: {
        SECTION: 'Uygulamalar',
        APPLICATIONS: 'Uygulamalar',
        LDAPSETTINGS: 'LDAP Ayarları',
        LOGINAUDITLOG: 'Giriş Denetim Kaydı',
        AIRCRAFT: 'Uçak Tipleri',
        AVIATIONFUELALIASES: 'Havacılık Yakıt Eşlemeleri',
      },
      AUTHORIZATION: {
        SECTION: 'Yetkilendirme',
        OVERVIEW: 'Genel Bakış',
        PERMISSIONS: 'İzinler',
        ROLES: 'Roller',
        ENDPOINTS: 'API Endpointleri',
      },
      INTEGRATIONS: {
        SECTION: 'Entegrasyonlar',
      },
      SUPPLIERSS: {
        SECTION: 'Tedarikçiler',
      },
      WATER_FOOTPRINT: {
        SECTION: 'Su Ayak İzi',
        TITLE: 'Su Ayak İzi',
      },
      REPORTS: {
        SECTION: 'Raporlar',
        EMISSION: 'Emisyon Raporu',
        EMISSION_BY_CATEGORY: 'Kategoriye Göre Emisyon Verileri',
        UNCERTAINTY: 'Belirsizlik Raporu',
        CREATE: 'Rapor Oluştur',
        REPORT: 'Raporlama',
      },
      TESTMENU: {
        HEADER: 'Menü Başlığı',
        SECTION: 'Ana Menü',
        SUBMENU: 'Alt Menü 1',
        SUBMENU2: 'Alt Menü 2',
        SUBMENU2SUB: {
          TESTSUBMENU: 'Test Alt Menü',
          TESTSUBMENU2: 'Test Alt Menü 2',
        },
      },
    },
  },
};
